var map = {
	"./avatar-1.jpg": 33222,
	"./avatar-2.jpg": 45649,
	"./avatar-3.jpg": 14637,
	"./avatar-4.jpg": 74898,
	"./avatar-5.jpg": 39801,
	"./icons8-facebook-48.png": 17553,
	"./image 2.png": 94590,
	"./imglogo.png": 70599,
	"./logo.png": 29935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25409;